import { css } from "../helpers/webComponents";

const styles: string = css`
    :host {
        display: block;
        padding: 0;
        margin: 0;
        text-align: center;
    }

    button {
        margin: 0;
        padding: 0;
        background: none;
        border: none;
        cursor: pointer;
        font-size: 40px;
        position: absolute;
        top: 43px;
        left: 260px;
        z-index: 2;
    }

    @media (max-width: 1024px) {
        button {
            top: 40px; /* Adjust vertical position */
            left: 0px; /* Adjust horizontal position */
        }
    }

    @media (max-width: 480px) {
        button {
            font-size: 35px;
        }
    }

    button:hover {
        opacity: 0.8;
    }

    .icon {
        display: inline-block;
        image-rendering: pixelated; /* This creates a pixelated effect */
        -ms-interpolation-mode: nearest-neighbor;
    }
`;

export class MusicPlayerComponent extends HTMLElement {
    private audio: HTMLAudioElement;
    private isPlaying: boolean;

    public constructor() {
        super();
        this.audio = new Audio("/assets/audio/game music.mp3");
        this.audio.loop = true;
        this.isPlaying = false;
    }

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });

        if (!this.shadowRoot) return;

        this.shadowRoot.innerHTML = `
            <style>${styles}</style>
            <div>
                <button id="playPause">
                    <span id="icon" class="icon">&#128263;</span> <!-- Speaker Icon (Unicode) -->
                </button>
            </div>
        `;

        this.shadowRoot.querySelector("#playPause")?.addEventListener("click", () => this.toggleMusic());
    }

    private toggleMusic(): void {
        if (this.isPlaying) {
            this.stopMusic();
        }
        else {
            this.playMusic();
        }
    }

    private playMusic(): void {
        void this.audio.play();
        this.isPlaying = true;

        this.updateButton();
    }

    private stopMusic(): void {
        this.audio.pause();
        this.audio.currentTime = 0;
        this.isPlaying = false;

        this.updateButton();
    }

    private updateButton(): void {
        const icon: Element | null | undefined = this.shadowRoot?.querySelector("#icon");

        if (this.isPlaying) {
            if (icon) icon.innerHTML = "&#128266;";
        }
        else {
            if (icon) icon.innerHTML = "&#128263;";
        }
    }
}
